const SaludoDespedida = () => {
  return (
    <>
      <h2 className="text-danger"> Adios :(</h2>
    </>
  );
};

export default SaludoDespedida;
